/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Assistant_Activity_NoopInputs */



/**
* | output |
* | --- |
* | "No changes needed in {group}" |
*
* @param {Assistant_Activity_NoopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_noop = /** @type {((inputs: Assistant_Activity_NoopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_NoopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Aucune modification nécessaire dans ${i?.group}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`In ${i?.group} sind keine Änderungen erforderlich.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Non sono necessarie modifiche in ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`В ${i?.group} никаких изменений не требуется`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No es necesario realizar cambios en ${i?.group}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.group} 无需更改`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group} に変更は必要ありません`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में किसी बदलाव की आवश्यकता नहीं है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Nenhuma alteração necessária em ${i?.group}`)
	return /** @type {LocalizedString} */ (`No changes needed in ${i?.group}`)
});